import { deviationConstants } from './deviation.constants'

const initialState = {
  deviations: [],

  deviationTypes: [],
  loadingDeviationTypes: false,

  deviationStatuses: [],
  loadingDeviationStatuses: false,

  deviationPriorities: [],
  loadingDeviationPriorities: false,

  deviationTags: [],
  loadingDeviationTags: false,

  creatingDeviation: false,
  updatingDeviation: false,
  savingDeviationFollowUp: false,
  loadingDeviations: false,
  error: null,
  followUpError: null,
}

export function deviations(state = initialState, action) {
  switch (action.type) {
    case deviationConstants.CREATING_DEVIATION:
      return {
        ...state,
        creatingDeviation: true,
      }
    case deviationConstants.CREATING_DEVIATION_SUCCESS:
      return {
        ...state,
        creatingDeviation: false,
      }
    case deviationConstants.CREATING_DEVIATION_ERROR:
      return {
        ...state,
        creatingDeviation: false,
        error: action.error,
      }
    case deviationConstants.UPDATE_DEVIATION:
      return {
        ...state,
        updatingDeviation: true,
      }
    case deviationConstants.UPDATE_DEVIATION_SUCCESS:
      return {
        ...state,
        updatingDeviation: false,
      }
    case deviationConstants.UPDATE_DEVIATION_ERROR:
      return {
        ...state,
        updatingDeviation: false,
      }
    case deviationConstants.SUBMIT_DEVIATION_FOLLOWUP:
      return {
        ...state,
        savingDeviationFollowUp: true,
      }
    case deviationConstants.SUBMIT_DEVIATION_FOLLOWUP_SUCCESS:
      return {
        ...state,
        savingDeviationFollowUp: false,
      }
    case deviationConstants.SUBMIT_DEVIATION_FOLLOWUP_ERROR:
      return {
        ...state,
        savingDeviationFollowUp: false,
        followUpError: action.error,
      }
    case deviationConstants.FETCHING_DEVIATIONS_FOR_BOAT:
      return {
        ...state,
        loadingDeviations: true,
      }
    case deviationConstants.FETCH_DEVIATIONS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingDeviations: false,
        deviations: action.deviations,
      }
    case deviationConstants.FETCH_DEVIATIONS_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingDeviations: false,
        error: action.error,
      }

    // TYPE
    case deviationConstants.FETCHING_DEVIATION_TYPES:
      return {
        ...state,
        loadingDeviationTypes: true,
      }
    case deviationConstants.FETCH_DEVIATION_TYPES_SUCCESS:
      return {
        ...state,
        loadingDeviationTypes: false,
        deviationTypes: action.deviationTypes,
      }
    case deviationConstants.FETCHING_DEVIATION_TYPES_ERROR:
      return {
        ...state,
        loadingDeviationTypes: false,
        error: action.error,
      }

    // STATUS
    case deviationConstants.FETCHING_DEVIATION_STATUS:
      return {
        ...state,
        loadingDeviationStatuses: true,
      }
    case deviationConstants.FETCH_DEVIATION_STATUS_SUCCESS:
      return {
        ...state,
        loadingDeviationStatuses: false,
        deviationStatuses: action.deviationStatuses,
      }
    case deviationConstants.FETCHING_DEVIATION_STATUS_ERROR:
      return {
        ...state,
        loadingDeviationStatuses: false,
        error: action.error,
      }

    // PRIORITIES
    case deviationConstants.FETCHING_DEVIATION_PRIORITIES:
      return {
        ...state,
        loadingDeviationPriorities: true,
      }
    case deviationConstants.FETCH_DEVIATION_PRIORITIES_SUCCESS:
      return {
        ...state,
        loadingDeviationPriorities: false,
        deviationPriorities: action.deviationPriorities,
      }
    case deviationConstants.FETCHING_DEVIATION_PRIORITIES_ERROR:
      return {
        ...state,
        loadingDeviationPriorities: false,
        error: action.error,
      }
    //TAGS
    case deviationConstants.FETCH_DEVIATION_TAGS_LOADING:
      return {
        ...state,
        loadingDeviationTags: true,
      }
    case deviationConstants.FETCH_DEVIATION_TAGS_SUCCESS:
      return {
        ...state,
        loadingDeviationTags: false,
        deviationTags: action.deviationTags,
      }
    case deviationConstants.FETCH_DEVIATION_TAGS_ERROR:
      return {
        ...state,
        loadingDeviationTags: false,
        error: action.error,
      }
    default:
      return state
  }
}
